<template>
  <div class="verify-email-content">
    <div class="text text-md">We sent you an email with a confirmation link and a 6-digit code.</div>
    <div class="text text-md">
      If you don’t see it, check your spam or junk folder, or
      <button
        type="button"
        class="link-button resend-button link-underlined"
        :disabled="resendLoading"
        :aria-busy="resendLoading ? 'true' : 'false'"
        @click="resendVerifyEmail"
      >
        {{ resendLoading ? 'Sending...' : 'resend the email' }}
      </button>
      <span v-if="resendLoading" class="sr-only" role="status" aria-live="polite" aria-atomic="true">
        Resending verification email
      </span>
    </div>
    <div v-if="resendError" class="error resend-error" role="alert">{{ resendError }}</div>
    <mcr-button-router-link :to="requireVerifyRoute" @click="onEnterCodeClick"
      >Enter verification code</mcr-button-router-link
    >
  </div>
</template>

<script>
import McrButtonRouterLink from '@common/elements/buttons/mcrButtonRouterLink';

export default {
  data() {
    return {
      resendLoading: false,
      resendError: '',
    };
  },
  computed: {
    redirectTarget() {
      return this.$route.query.redirect || this.$route.fullPath;
    },
    requireVerifyRoute() {
      return {name: 'require-verify', query: {redirect: this.redirectTarget}};
    },
  },
  methods: {
    onEnterCodeClick() {
      this.$emit('enter-code');
    },
    resendVerifyEmail() {
      if (this.resendLoading) {
        return;
      }

      this.resendLoading = true;
      this.resendError = '';
      this.network.member
        .resendVerifyEmail()
        .then(() => {
          this.$router.push({name: 'require-verify', query: {resent: 'true', redirect: this.redirectTarget}});
          this.$emit('resent');
        })
        .catch(error => {
          const message = error && error.response && error.response.data && error.response.data.error;
          this.resendError = message || 'Unable to resend verification email. Please try again.';
        })
        .finally(() => {
          this.resendLoading = false;
        });
    },
  },
  name: 'VerifyEmailContent',
  components: {McrButtonRouterLink},
};
</script>

<style scoped lang="scss">
@use '@common/style/variables' as *;

.verify-email-content {
  .text {
    color: $neutral-600;
    margin: 16px 0;
  }

  .mcr-button,
  .resend-error {
    margin-top: 16px;
  }

  .resend-button {
    color: inherit;

    &:disabled {
      background: transparent;
      border-color: transparent;
      color: $neutral-400;
      cursor: not-allowed;
      text-decoration: none;
    }
  }

  .mcr-button-router-link {
    width: 100%;
  }
}
</style>
